// SNIGJ - DRC Administrative Hierarchy Data

export const DRC_ADMINISTRATIVE_HIERARCHY = {
  // Provinces with their subdivisions
  provinces: [
    {
      id: "kinshasa",
      name: "KINSHASA",
      type: "ville-province",
      communes: [
        { id: "gombe", name: "Gombe", quartiers: ["Centre-ville", "Socimat", "Cliniques", "Royal"] },
        { id: "lingwala", name: "Lingwala", quartiers: ["Matonge", "Immocongo", "Limite", "Lisala"] },
        { id: "barumbu", name: "Barumbu", quartiers: ["Centre", "Boyoma", "Mombele", "Ngiri-Ngiri"] },
        { id: "kinshasa", name: "Kinshasa", quartiers: ["Victoire", "Makelele", "Kasavubu", "Assossa"] },
        { id: "kintambo", name: "Kintambo", quartiers: ["Brikin", "Jamaïque", "Magasin", "Mbinza"] },
        { id: "ngaliema", name: "Ngaliema", quartiers: ["Binza-UPN", "Binza-Pigeon", "Joli-Parc", "Ma Campagne"] },
        { id: "mont-ngafula", name: "Mont-Ngafula", quartiers: ["Kindele", "Mama Mobutu", "Mitendi", "Ngansele"] },
        { id: "selembao", name: "Selembao", quartiers: ["Badiadingi", "Kinsuka", "Madiata", "Mbala"] },
        { id: "bumbu", name: "Bumbu", quartiers: ["Camp Luka", "Mongala", "Selembao", "Tshimanga"] },
        { id: "makala", name: "Makala", quartiers: ["Kwamwenge", "Matonge", "Ngaba", "Yolo-Nord"] },
        { id: "ngiri-ngiri", name: "Ngiri-Ngiri", quartiers: ["Assossa", "Kapela", "Lisanga", "Mbamu"] },
        { id: "kalamu", name: "Kalamu", quartiers: ["Kimbangu", "Matonge", "Yolo-Sud", "Djelo-Binza"] },
        { id: "lemba", name: "Lemba", quartiers: ["Camp Kokolo", "Funa", "Righini", "Salongo"] },
        { id: "limete", name: "Limete", quartiers: ["Foire", "Industriel", "Kingabwa", "Mombele"] },
        { id: "matete", name: "Matete", quartiers: ["Debonhomme", "Nzadi", "Tomba", "Mbaki"] },
        { id: "ndjili", name: "N'djili", quartiers: ["CECOMAF", "Maviokele", "Sans-Fil", "Tshangu"] },
        { id: "kimbanseke", name: "Kimbanseke", quartiers: ["Dialecte", "Kingasani", "Mikonga", "Mpasa"] },
        { id: "masina", name: "Masina", quartiers: ["Abattoir", "Mfumu-Mvula", "Petro-Congo", "Sans-Fil"] },
        { id: "nsele", name: "N'sele", quartiers: ["Cité Mama Mobutu", "Kinkole", "Mikili", "Mpasa"] },
        { id: "maluku", name: "Maluku", quartiers: ["Centre", "Kimpoko", "Menkao", "Mongata"] }
      ]
    },
    {
      id: "kongo-central",
      name: "KONGO-CENTRAL",
      type: "province",
      territoires: [
        { 
          id: "matadi", 
          name: "Matadi (Chef-lieu)", 
          type: "ville",
          communes: [
            { id: "matadi", name: "Matadi", quartiers: ["Centre", "Mvuzi", "Nzanza"] },
            { id: "mvuzi", name: "Mvuzi", quartiers: ["Soyo", "Kinkanda", "Dingi-Dingi"] },
            { id: "nzanza", name: "Nzanza", quartiers: ["Lufu", "Mpozo", "Nkenge"] }
          ]
        },
        { id: "boma", name: "Boma", type: "ville" },
        { id: "moanda", name: "Moanda", type: "territoire" },
        { id: "lukula", name: "Lukula", type: "territoire" },
        { id: "tshela", name: "Tshela", type: "territoire" },
        { id: "seke-banza", name: "Seke-Banza", type: "territoire" },
        { id: "luozi", name: "Luozi", type: "territoire" },
        { id: "mbanza-ngungu", name: "Mbanza-Ngungu", type: "territoire" },
        { id: "songololo", name: "Songololo", type: "territoire" },
        { id: "madimba", name: "Madimba", type: "territoire" },
        { id: "kasangulu", name: "Kasangulu", type: "territoire" },
        { id: "kimvula", name: "Kimvula", type: "territoire" }
      ]
    },
    {
      id: "haut-katanga",
      name: "HAUT-KATANGA",
      type: "province",
      territoires: [
        { id: "lubumbashi", name: "Lubumbashi (Chef-lieu)", type: "ville" },
        { id: "likasi", name: "Likasi", type: "ville" },
        { id: "kolwezi", name: "Kolwezi", type: "ville" },
        { id: "kipushi", name: "Kipushi", type: "territoire" },
        { id: "sakania", name: "Sakania", type: "territoire" },
        { id: "kambove", name: "Kambove", type: "territoire" },
        { id: "kasenga", name: "Kasenga", type: "territoire" },
        { id: "mitwaba", name: "Mitwaba", type: "territoire" },
        { id: "pweto", name: "Pweto", type: "territoire" }
      ]
    },
    {
      id: "nord-kivu",
      name: "NORD-KIVU",
      type: "province",
      territoires: [
        { id: "goma", name: "Goma (Chef-lieu)", type: "ville" },
        { id: "beni", name: "Beni", type: "ville" },
        { id: "butembo", name: "Butembo", type: "ville" },
        { id: "lubero", name: "Lubero", type: "territoire" },
        { id: "masisi", name: "Masisi", type: "territoire" },
        { id: "nyiragongo", name: "Nyiragongo", type: "territoire" },
        { id: "rutshuru", name: "Rutshuru", type: "territoire" },
        { id: "walikale", name: "Walikale", type: "territoire" }
      ]
    },
    {
      id: "sud-kivu",
      name: "SUD-KIVU",
      type: "province",
      territoires: [
        { id: "bukavu", name: "Bukavu (Chef-lieu)", type: "ville" },
        { id: "uvira", name: "Uvira", type: "territoire" },
        { id: "fizi", name: "Fizi", type: "territoire" },
        { id: "kabare", name: "Kabare", type: "territoire" },
        { id: "kalehe", name: "Kalehe", type: "territoire" },
        { id: "mwenga", name: "Mwenga", type: "territoire" },
        { id: "shabunda", name: "Shabunda", type: "territoire" },
        { id: "walungu", name: "Walungu", type: "territoire" }
      ]
    },
    { id: "kwango", name: "KWANGO", type: "province" },
    { id: "kwilu", name: "KWILU", type: "province" },
    { id: "mai-ndombe", name: "MAI-NDOMBE", type: "province" },
    { id: "kasai", name: "KASAÏ", type: "province" },
    { id: "kasai-central", name: "KASAÏ-CENTRAL", type: "province" },
    { id: "kasai-oriental", name: "KASAÏ-ORIENTAL", type: "province" },
    { id: "lomami", name: "LOMAMI", type: "province" },
    { id: "sankuru", name: "SANKURU", type: "province" },
    { id: "maniema", name: "MANIEMA", type: "province" },
    { id: "ituri", name: "ITURI", type: "province" },
    { id: "haut-uele", name: "HAUT-UELE", type: "province" },
    { id: "tshopo", name: "TSHOPO", type: "province" },
    { id: "bas-uele", name: "BAS-UELE", type: "province" },
    { id: "nord-ubangi", name: "NORD-UBANGI", type: "province" },
    { id: "sud-ubangi", name: "SUD-UBANGI", type: "province" },
    { id: "mongala", name: "MONGALA", type: "province" },
    { id: "equateur", name: "ÉQUATEUR", type: "province" },
    { id: "tshuapa", name: "TSHUAPA", type: "province" },
    { id: "tanganyika", name: "TANGANYIKA", type: "province" },
    { id: "haut-lomami", name: "HAUT-LOMAMI", type: "province" },
    { id: "lualaba", name: "LUALABA", type: "province" }
  ]
};

// Judicial hierarchy levels
export const JUDICIAL_HIERARCHY = [
  { id: "police_locale", name: "Police Locale", level: 1 },
  { id: "police_urbaine", name: "Police Urbaine/Territoriale", level: 2 },
  { id: "parquet_paix", name: "Parquet près le Tribunal de Paix", level: 3 },
  { id: "tribunal_paix", name: "Tribunal de Paix", level: 4 },
  { id: "parquet_grande_instance", name: "Parquet près le TGI", level: 5 },
  { id: "tribunal_grande_instance", name: "Tribunal de Grande Instance", level: 6 },
  { id: "parquet_general", name: "Parquet Général", level: 7 },
  { id: "cour_appel", name: "Cour d'Appel", level: 8 },
  { id: "parquet_general_cour_cassation", name: "Parquet Général près la Cour de Cassation", level: 9 },
  { id: "cour_cassation", name: "Cour de Cassation", level: 10 },
  { id: "cour_constitutionnelle", name: "Cour Constitutionnelle", level: 11 },
  { id: "ministere_justice", name: "Ministère de la Justice", level: 12 }
];

// Case assignment status
export const CASE_ASSIGNMENT_STATUS = [
  "ASSIGNED",
  "TRANSFERRED",
  "PENDING_TRANSFER",
  "RETURNED",
  "ARCHIVED"
];

// Export provinces as a simple array for dropdowns
export const DRC_PROVINCES = DRC_ADMINISTRATIVE_HIERARCHY.provinces.map(p => ({
  code: p.id.toUpperCase().replace(/-/g, '_'),
  name: p.name,
  type: p.type
}));

export default DRC_ADMINISTRATIVE_HIERARCHY;
